module.exports = __webpack_public_path__ + "img/wdbg.b436fa05.png";